import React from "react";
import  FootlerWrapper  from "../../../../components/FootlerWrapper/FootlerWrapper";
import "./style.scss";

const FootlerSubsection = () => {
  return <FootlerWrapper className="footler" />;
};
export default FootlerSubsection;